import { Field, Image, ImageField, Link, LinkField, RichText, Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';
import SearchBar from 'src/components/search/SearchBar/SearchBar';

import styles from './SearchHeroBlock.module.css';

type SearchHeroBlockProps = ComponentProps & {
	fields: {
		DesktopHeading: Field<string>;
		DesktopSubtitle: Field<string>;
		MobileHeading: Field<string>;
		MobileBody: Field<string>;
		DesktopBody: Field<string>;
		LargeScreenImage: ImageField;
		SmallScreenImage: ImageField;
		SearchPlaceholderText: Field<string>;
		SearchPlaceholderTextMobile: Field<string>;
		SearchButtonText: Field<string>;
		SearchResultsPage: LinkField;
	};
};

export default withDatasourceCheck()<SearchHeroBlockProps>(SearchHeroBlock);

function SearchHeroBlock(props: SearchHeroBlockProps): JSX.Element {
	return (
		<section className={styles.section}>
			<div className="maxWidth">
				<header className={`${styles.textContainer}`}>
					<div className={`${styles.header} padX padY`}>
						<Text className={styles.mobileHeading} tag={'h2'} field={props.fields.MobileHeading} />
						<RichText className={styles.mobileBody} tag={'p'} field={props.fields.MobileBody} />

						<Text tag="h1" className={styles.desktopHeading} field={props.fields.DesktopHeading}></Text>
						<Text className={styles.desktopSubtitle} tag={'h2'} field={props.fields.DesktopSubtitle} />
						<RichText className={styles.largeScreenText} field={props.fields.DesktopBody} />

						<SearchBar {...(props as ComponentProps)} fields={props.fields} integrated />

						<Link field={props.fields.SearchResultsPage} className={`${styles.link} link linkOffset linkHoverWeighted`} />
					</div>
				</header>
			</div>

			<EditorHelp text="Image maxWidth 1440px" />
			<EditorHelp text="Image for small screens maxWidth 600px" />

			<div className={styles.imageWrapper}>
				<Image
					className={`${styles.image} ${styles.desktop}`}
					media={props.fields.LargeScreenImage}
					loading="lazy"
					height={699}
					width={1440}
				/>
			</div>
			<div className={`${styles.imageWrapper} ${styles.mobileImageWrapper}`}>
				<Image
					className={`${styles.image} ${styles.mobile}`}
					media={props.fields.SmallScreenImage}
					loading="lazy"
					height={400}
					width={600}
				/>
			</div>
		</section>
	);
}
